// extracted by mini-css-extract-plugin
export default {"wrapper":"ProfileViewPage_wrapper__28M8G"};